export default __webpack_public_path__ + "static/media/google-authenticator.f258c9e4.svg";